type serviceAreaParms = {
  sigungu_code: string[];
};

const serviceAreaData: {
  [key: string]: serviceAreaParms;
} = require('./json/offline_servicearea.json');

let serviceAreaNetData: {
  [key: string]: serviceAreaParms;
};

(async () => {
  try {
    // package.json "proxy": "https://mintwk.edge.naverncp.com"
    const response = await fetch(
      'https://mintwk.edge.naverncp.com/mint-house/offline_servicearea.json',
      {
        cache: 'no-cache',
        mode: 'cors',
        // credentials: 'include',
        // headers: {
        //   'access-control-allow-origin': '*',
        //   'Content-type': 'application/json; charset=UTF-8',
        // },
      },
    );
    serviceAreaNetData = await response.json();
  } catch (error) {
    console.error('🆘 sigungu_code', error);
  }
})();

export const serviceAreaAry = (): any => {
  if (!serviceAreaNetData || !serviceAreaNetData['sigungu_code']) {
    if (!serviceAreaData || !serviceAreaData['sigungu_code']) {
      return [];
    }
    return serviceAreaData['sigungu_code'];
  }
  return serviceAreaNetData['sigungu_code'];
};
